export default [
  'M35.855 32.968H4.597l.478.817L20.704 6.008h-.956l15.629 27.777.478-.817zm0 1.097c.42 0 .683-.452.478-.818L20.703 5.47a.548.548 0 0 0-.955 0L4.118 33.247a.548.548 0 0 0 .479.818h31.258z',
  'M19.883 15.307v8.095a.548.548 0 1 0 1.097 0v-8.095a.548.548 0 1 0-1.097 0zM20.431 26.01c-.87 0-1.576.703-1.576 1.576 0 .867.706 1.577 1.576 1.577.87 0 1.576-.71 1.576-1.577 0-.873-.706-1.576-1.576-1.576',
];
